import { FC, useState } from 'react'
import { SequenceMenu } from '@sequencehq/core-components'
import { CreditNoteIssueDialog } from 'CreditNotes/components/dialog/CreditNoteIssue'

type Props = {
  creditNoteId: string
}

export const SendCreditNoteMenuItem: FC<Props> = ({ creditNoteId }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <SequenceMenu.Item
        uuid="send-credit-note"
        data-testid={`creditNotes.${creditNoteId}.menuItem.finalizeAndSend`}
        label="Issue and send credit note"
        onClick={e => {
          e.stopPropagation()
          setShowModal(true)
        }}
      />
      {showModal && (
        <CreditNoteIssueDialog
          creditNoteId={creditNoteId}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  )
}
